import { Patient } from '../../../providers/Patients/types'
import { PatientTableRow } from './types'

export const formatPatientsForTable = (
  apiPatients: Patient
): PatientTableRow => ({
  ...apiPatients,
  patientId: apiPatients.patientId,
  preferredName: apiPatients.preferredName,
  vrName: apiPatients.vrName,
  mrn: apiPatients.mrn,
  // isActive: apiPatients.isActive,
  deactivationDate: apiPatients.deactivationDate || 'N/A',
  providerRole: apiPatients.providerRole,
  accessRoles: apiPatients.accessRoles
    ? apiPatients.accessRoles[0].description
    : '',
  lastBACDate: apiPatients.lastBACDate,
  lastBACValue: apiPatients.lastBACValue,
})
